import { ValidatorFn, AbstractControl } from '@angular/forms';
import { isInvalidValue } from 'src/app/analyses/components/add/from-to.validator';

export const systolicDiastolicValidator: ValidatorFn = (
  form: AbstractControl
) => {
  const systolic = form.get('systolic').value;
  const diastolic = form.get('diastolic').value;

  if (isInvalidValue(systolic) || isInvalidValue(diastolic)) {
    return null;
  }

  if (Number(systolic) <= Number(diastolic)) {
    return { smallerGreater: true };
  }
  return null;
};
